import {
  FormHelperText as MUIFormHelperText,
  type FormHelperTextProps,
} from '@mui/material';

export { type FormHelperTextProps } from '@mui/material';

export function FormHelperText(props: FormHelperTextProps) {
  return <MUIFormHelperText {...props} />;
}
